module.exports = __webpack_public_path__ + "static/media/jaybox-logo-white.0c7cd27e.svg";